import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { QueryStatus } from "../../../utils";
import { RootState } from "../../../redux/store";
import {
  HomeChargingSupportingDocument,
  HomeChargingSupportingDocumentsToCreate,
} from "./homeChargingSupportingDocumentsAPI";
import { fakeHomeChargingSupportingDocuments } from "./homeChargingSupportingDocumentsFakeData";

export interface HomeChargingSupportingDocumentsState {
  homeChargingSupportingDocumentsStatus: QueryStatus;
  homeChargingSupportingDocuments: HomeChargingSupportingDocument[];
  createHomeChargingSupportingDocumentsStatus: QueryStatus;
}

const initialState: HomeChargingSupportingDocumentsState = {
  homeChargingSupportingDocumentsStatus: "idle",
  homeChargingSupportingDocuments: [],
  createHomeChargingSupportingDocumentsStatus: "idle",
};

export const getHomeChargingSupportingDocumentsAsync = createAsyncThunk(
  "getHomeChargingSupportingDocumentsAsync/call",
  () => {
    return fakeHomeChargingSupportingDocuments;
  },
);

export const createHomeChargingSupportingDocumentsAsync = createAsyncThunk(
  "createHomeChargingSupportingDocuments/call",
  (supportingDocumentsToCreate: HomeChargingSupportingDocumentsToCreate) => {
    return supportingDocumentsToCreate;
  },
);

export const homeChargingSupportingDocumentsSlice = createSlice({
  name: "homeChargingSupportingDocuments",
  initialState,
  reducers: {
    resetHomeChargingSupportingDocumentsStatus(state) {
      state.homeChargingSupportingDocumentsStatus = "idle";
    },
    resetCreateHomeChargingSupportingDocumentsStatus(state) {
      state.createHomeChargingSupportingDocumentsStatus = "idle";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHomeChargingSupportingDocumentsAsync.pending, (state) => {
        state.homeChargingSupportingDocumentsStatus = "processing";
      })
      .addCase(
        getHomeChargingSupportingDocumentsAsync.fulfilled,
        (state, action) => {
          state.homeChargingSupportingDocumentsStatus = "success";
          state.homeChargingSupportingDocuments = action.payload;
        },
      )
      .addCase(getHomeChargingSupportingDocumentsAsync.rejected, (state) => {
        state.homeChargingSupportingDocumentsStatus = "failed";
      })
      .addCase(createHomeChargingSupportingDocumentsAsync.pending, (state) => {
        state.createHomeChargingSupportingDocumentsStatus = "processing";
      })
      .addCase(
        createHomeChargingSupportingDocumentsAsync.fulfilled,
        (state) => {
          state.createHomeChargingSupportingDocumentsStatus = "success";
        },
      )
      .addCase(createHomeChargingSupportingDocumentsAsync.rejected, (state) => {
        state.createHomeChargingSupportingDocumentsStatus = "failed";
      });
  },
});

export const selectHomeChargingSupportingDocumentsStatus = (state: RootState) =>
  state.homeChargingSupportingDocuments.homeChargingSupportingDocumentsStatus;

export const selectHomeChargingSupportingDocuments = (state: RootState) =>
  state.homeChargingSupportingDocuments.homeChargingSupportingDocuments;

export const selectCreateHomeChargingSupportingDocumentsStatus = (
  state: RootState,
) =>
  state.homeChargingSupportingDocuments
    .createHomeChargingSupportingDocumentsStatus;

export default homeChargingSupportingDocumentsSlice.reducer;
